import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar } from "lucide-react";
import { api } from "@/lib/api";

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "long", year: "numeric" });
  } catch {
    return "";
  }
}

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/posts")
      .then((res) => setPosts(res.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-blog">
      <section className="section">
        <div className="container-narrow">
          <div className="max-w-2xl">
            <span className="text-eyebrow">Artigos</span>
            <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl mt-5 leading-[1.1] text-[#2C352D]">
              Reflexões sobre escuta,<br /> sofrimento e elaboração.
            </h1>
            <p className="mt-8 text-[#5B685C] text-lg leading-relaxed font-light">
              Textos para pensar — sobre ansiedade, adolescência, autoconhecimento e a clínica psicanalítica.
            </p>
          </div>

          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="blog-grid">
            {loading && <p className="text-[#5B685C] font-light">Carregando artigos...</p>}
            {!loading && posts.length === 0 && (
              <p data-testid="blog-empty" className="text-[#5B685C] font-light italic">
                Em breve, novos artigos por aqui.
              </p>
            )}
            {posts.map((p) => (
              <article
                key={p.id}
                data-testid={`blog-card-${p.slug}`}
                className="group bg-white rounded-3xl overflow-hidden border border-[#8BA88E]/10 soft-shadow hover-shadow transition-all duration-300"
              >
                {p.cover_image && (
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={p.cover_image.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${p.cover_image}` : p.cover_image}
                      alt={p.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    />
                  </div>
                )}
                <div className="p-7 md:p-8">
                  <div className="flex items-center gap-2 text-eyebrow text-[#8BA88E]">
                    <Calendar size={12} /> {formatDate(p.created_at)}
                  </div>
                  <h2 className="font-serif text-2xl text-[#2C352D] mt-3 leading-tight">
                    {p.title}
                  </h2>
                  <p className="mt-3 text-[#5B685C] font-light line-clamp-3">{p.excerpt}</p>
                  <Link
                    to={`/blog/${p.slug}`}
                    data-testid={`blog-read-${p.slug}`}
                    className="inline-flex items-center gap-2 mt-5 text-[#8BA88E] hover:text-[#769379] font-medium"
                  >
                    Ler artigo <ArrowRight size={16} />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
